import React from 'react'

import classnames from 'classnames'
import PropTypes from 'prop-types'

import {
  INPUTGROUP_VARIANT_DANGER,
  INPUTGROUP_VARIANT_DEFAULT
} from './InputGroup.constants'
import {
  StyledInputGroup,
  StyledInputGroupSeparator
} from './InputGroup.styles'

const baseCN = 'e-input-group'

export const InputGroup = ({
  className,
  variant,
  disabled,
  'data-mu-test': dataAttributeTest,
  children
}) => {
  return (
    <StyledInputGroup
      className={classnames(
        baseCN,
        {
          [`${baseCN}--${variant}`]: variant,
          [`${baseCN}--disabled`]: disabled
        },
        className
      )}
      data-mu-test={dataAttributeTest}
      $variant={variant}
      $disabled={disabled}
    >
      {children}
    </StyledInputGroup>
  )
}

InputGroup.defaultProps = {
  disabled: false,
  variant: INPUTGROUP_VARIANT_DEFAULT
}

InputGroup.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    INPUTGROUP_VARIANT_DEFAULT,
    INPUTGROUP_VARIANT_DANGER
  ]),
  disabled: PropTypes.bool,
  'data-mu-test': PropTypes.string,
  children: PropTypes.node
}

export const InputGroupSeparator = StyledInputGroupSeparator
